import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";


export interface OrderChannelStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderChannel?: TypographyProps;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const orderChannelStyles: OrderChannelStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;
            font-family: 'Lato',sans-serif;
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: .31250625rem;
            margin-right: 0.3125rem;
            color: #002554;
            font-size: 0.875rem;
            font-family: 'Roboto', sans-serif;
            font-weight: bold;
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    orderChannel: {
        css: css`
            color: #333F48;
            font-size: 0.875rem;
    `,
    },
};

const styles = orderChannelStyles;

const OrderChannel: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);
    if ((!order || !order.properties?.orderChannel)&&(!orderData||!orderData.properties?.orderChannel)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderChannel">
                {translate("Order Channel")}
            </Typography>

            <Typography {...styles.orderChannel} aria-labelledby="orderChannel">
                {order?.properties?.orderChannel||orderData?.properties?.orderChannel}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderChannel),
    definition: {
        allowedContexts: [OrderDetailsPageContext,"OrderStatusPage"],
        group: "Order Details",
    },
};

export default widgetModule;
